import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Link, useNavigate } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Ratio from 'react-bootstrap/Ratio';
import Logo from '../../../logo.png';
import ForgotPassBanner from '../../../assets/images/authentication-banner.jpg';
import { SvgIcons } from '../../../components/common/SvgIcons';
import { loginWithVerificationCode, resendMFACode } from '../../../services/authService';
import SnackbarToast from '../../../components/common/SnackBar';
import Loader from '../../../components/common/Loader';
import storage from '../../../helpers/storage';

export const MultifactorAuth = () => {
    const navigate = useNavigate()
    const [code, setcode] = useState(new Array(6).fill(""));
    const [loading, setLoading] = useState(false);
    const [disabled, setDisbaled] = useState(true);
    const userInformation: any = storage.getData('user-info');
    const [showSnackBar, setshowSnackBar] = useState({
        show: false,
        message: "",
        severity: ""
    });

    const handleClose = () => {
        setshowSnackBar({
            show: false,
            message: "",
            severity: ""
        })
    }


    /**
     * Code Manipulation
     *
     * @param {*} e
     * @param {number} index
     */
    const codeCreation = (e: any, index: number) => {
        const codeArray = [...code];
        codeArray[index] = e.target.value;
        const form = e.target.form;
        form[index + 1].focus();
        const verificationCode: string = code.join('');
        if (verificationCode.length === 5) {
            setDisbaled(false);
        } else {
            setDisbaled(true);
        }
        setcode(codeArray)

    }


    /**
     * Masking Email
     *
     * @param {string} [email='']
     * @returns {string}
     */
    const maskEmail = (email = '') => {
        const [name, domain] = email.split('@');
        const { length: len } = name;
        const maskedName = name[0] + '***' + name[len - 1];
        const maskedEmail = maskedName + '@' + domain;
        return maskedEmail;
    };


    /**
     * Submit Method to call when user enters the code and click on submit button
     *
     * @async
     * @param {*} e
     * @returns {*}
     */
    const submitForm = async (e: any) => {
        e.preventDefault();
        setLoading(true);
        const verificationCode: string = code.join('');
        
        loginWithVerificationCode({ 'user_id': userInformation.user_id, 'code': parseInt(verificationCode) }).then(response => {
            storage.setToken(response.tokens.access.token);
            storage.setRefreshToken(response.tokens.refresh.token);
            navigate('app/dashboard');
            setshowSnackBar({
                show: true,
                message: "Login Successfully",
                severity: 'success'
            });
        }).catch(error => {
            setLoading(false);
            setshowSnackBar({
                show: true,
                message: error.response.data.message,
                severity: 'error'
            });
        })
    }

    /**
     * Method to send the MFA Code again to the dedicated user
     *
     * @async
     * @returns {*}
     */
    const getNewMFACode = async () => {
        setLoading(true);
        resendMFACode({ 'user_id': userInformation.user_id}).then(response => {
            setLoading(false);
            setshowSnackBar({
                show: true,
                message: "Code Sent Successfully",
                severity: 'success'
            });
        }).catch(error => {
            setLoading(false);
            setshowSnackBar({
                show: true,
                message: error.response.data.message,
                severity: 'error'
            });
        })
    }
    return (
        <>
            <Row className="g-0 vh-100 position-relative">
                <Col sm className="mobileBannerActive h-100">
                    <Image className="h-100 object-fit-cover w-100" src={ForgotPassBanner} alt="Authenticate Your Account Banner" />
                </Col>
                <Col sm className="h-100">
                    <div className="h-100 overflow-auto p-4 p-md-5 text-center w-100">
                        <Row className="justify-content-center g-0">
                            <Col lg={10} xl={7} xxl={6}>
                                <div className="mb-5 pb-2">
                                    <Link to="/" className="d-inline-block">
                                        <Image className="img-fluid" src={Logo} alt="Logo" width={174} height={107} />
                                    </Link>
                                </div>
                                <div className="align-items-center d-inline-flex h-64 justify-content-center mb-2 rounded-circle w-64 bg-theme-light">
                                    {SvgIcons.lockIcon}
                                </div>
                                <h1 className="d-inline-block fw-bold h4 mb-1 mt-1 pt-2 w-100">Authenticate Your Account</h1>
                                <p className="mb-1 pt-1 px-lg-4">Please confirm your account by entering the authorization code sent to </p>
                                <p className="fw-bold mb-0">{maskEmail(userInformation?.email)}</p>
                                <Form className="text-start pt-4" onSubmit={submitForm}>
                                    <Form.Group className="mb-3 pb-1" controlId="formUserEmail">
                                        <Row className="gx-2 gx-lg-3 justify-content-between">
                                            {code.map((data, index) => {
                                                return (
                                                    <Col key={index}>
                                                        <Ratio aspectRatio="1x1 otpWidth">
                                                            <input
                                                                type="text"
                                                                className="form-control fs-15 p-2 rounded text-center"
                                                                name="otp"
                                                                maxLength={1}
                                                                placeholder="-"
                                                                onFocus={(e) => e.target.select}
                                                                autoFocus={index === 0}
                                                                onChange={(e: any) => codeCreation(e, index)}
                                                                style={{ borderColor: code[index] !== '' ? '#333333' : '#E0E3E6', borderWidth: code[index] !== '' ? '2px' : '1px' }}
                                                            />
                                                        </Ratio>
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                    </Form.Group>

                                    <Button className="fw-bold w-100" variant="primary" type="submit" disabled={disabled}>
                                        Submit
                                    </Button>
                                    <div className="text-center">
                                        <p className="pt-4 mb-1">It will take few minutes to receive your code.<br />Haven’t received it?</p>
                                        <Link to='#' onClick={getNewMFACode} className="text-decoration-none fw-bold">Resend a new code</Link>
                                    </div>
                                </Form>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <SnackbarToast showSnackBar={showSnackBar} handleClose={handleClose} />
            <Loader isLoading={loading} />
        </>
    )
}